import { io } from 'socket.io-client';

export const socket = io(process.env.REACT_APP_SERVER_URL, {
    path: '/socket.io',
    secure: true,
    autoConnect: true,
    withCredentials: true
});

